import React from "react";

export const Footer = () => {
    return (
        <div className="footerBox">
            <div>
                <a href="/privacypolicy" className="footerLink">
                    Privacy Policy
                </a>
                <a href="/about" className="footerLink">
                    About
                </a>
                <a href="/privacypolicy" className="footerLink">
                    Terms and Conditions
                </a>
            </div>
        </div>
    );
};
